import { render, staticRenderFns } from "./StorageBaseLocalStorage.vue?vue&type=template&id=427f72fa&"
import script from "./StorageBaseLocalStorage.vue?vue&type=script&lang=js&"
export * from "./StorageBaseLocalStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports